var path = '/static/assets/khapps2/base/navbar/team_select/test-select-tester.html';
var html = "<md-content layout-margin>\n    <team-select></team-select>\n</md-content>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;